import React from 'react';
import { SnackbarProvider } from 'notistack';

const Notifications = () => <SnackbarProvider maxSnack={3} />;

export default Notifications;
